
export interface IpcRenderer extends NodeJS.EventEmitter {
  [x: string]: any;
  //invoke(channel: string, ...args: any[]): Promise<any>;
  on(channel: string, listener: (event: IpcRendererEvent, ...args: any[]) => void): this;
  //once(channel: string, listener: (event: IpcRendererEvent, ...args: any[]) => void): this;
  //postMessage(channel: string, message: any, transfer?: MessagePort[]): void;
  //removeAllListeners(channel: string): this;
  removeListener(channel: string, listener: (...args: any[]) => void): this;
  send(channel: string, ...args: any[]): void;
  send<T>(channel: string, arg: T): void
  //sendSync(channel: string, ...args: any[]): any;
  //sendTo(webContentsId: number, channel: string, ...args: any[]): void;
  //sendToHost(channel: string, ...args: any[]): void;
}

export interface IpcRendererEvent extends Event {
  ports: MessagePort[];
  sender: IpcRenderer;
  senderId: number;
}

export function IpcRenderOn(channel: string, listener: (event: IpcRendererEvent, ...args: any[]) => void) {
  try {
    if (window.ipcRenderer) {
      window.ipcRenderer.on(channel, listener)
    }
  } catch (e) {
  }
}

export function IpcRenderRemove(channel: string, listener: (event: IpcRendererEvent, ...args: any[]) => void) {
  try {
    if (window.ipcRenderer) {
      window.ipcRenderer.removeListener(channel, listener)
    }
  } catch (e) {
  }
}

export function IpcRenderSend<T>(channel: string, arg: T) {
  try {
    if (window.ipcRenderer) {
      window.ipcRenderer.send<T>(channel, arg)
    }
  } catch (e) {
  }
}
